import React, { ReactElement } from "react"

import { ReportTableData } from "../../interfaces/dataInterfaces"

type Props = {
  reportData?: { errorList: string[]; warningList: string[]; extendedItems: ReportTableData[] }
}

function ReportValidation({ reportData }: Props): ReactElement {
  if (reportData?.errorList.length === 0 && reportData?.warningList.length === 0)
    return <p key="0">No error found in the data.</p>

  return (
    <>
      {reportData?.errorList.length === 0 ? null : <h3>Error(s)</h3>}
      {reportData?.errorList.map((error, index) => (
        <p key={error + index}>{error}</p>
      ))}
      {reportData?.warningList.length === 0 ? null : <h3>Warning(s)</h3>}
      {reportData?.warningList.map((warning, index) => (
        <p key={warning + index}>{warning}</p>
      ))}
    </>
  )
}

export default ReportValidation
